import { Types } from '../../../actions/dashboards'
import { Metrics } from '../../../constants/Dashboards'
import buildAsyncStatReducer from './asyncStatReducer'

/**
 * In Run Contenet reducer
 */
const inRunContentReducer = buildAsyncStatReducer({
    key: Metrics.INRUN_CONTENT,
    types: {
        request: Types.DASHBOARD_INRUN_CONTENT.request,
        success: Types.DASHBOARD_INRUN_CONTENT.success,
        failure: Types.DASHBOARD_INRUN_CONTENT.failure,
    },
    transform: (state, { payload }) => {
        const data = payload instanceof Array ? payload : []
        return data.map(({ content, count }) => ({
            content,
            count,
        }))
    },
})

/**
 * In Run Contenet Top reducer
 */
const inRunContentTopReducer = buildAsyncStatReducer({
    key: Metrics.INRUN_CONTENT_TOP,
    types: {
        request: Types.DASHBOARD_INRUN_CONTENT_TOP.request,
        success: Types.DASHBOARD_INRUN_CONTENT_TOP.success,
        failure: Types.DASHBOARD_INRUN_CONTENT_TOP.failure,
    },
    transform: (state, { payload }) => {
        const { content, count } = payload[0] || {}
        return { content, count }
    },
})

/**
 * In Run Dwell Time reducer
 */
const inRunDwellTime = buildAsyncStatReducer({
    key: Metrics.INRUN_DWELLTIME,
    types: {
        request: Types.DASHBOARD_INRUN_DWELLTIME.request,
        success: Types.DASHBOARD_INRUN_DWELLTIME.success,
        failure: Types.DASHBOARD_INRUN_DWELLTIME.failure,
    },
    transform: (state, { payload }) => {
        const { types } = payload
        return { types }
    },
})

/**
 * In Run Dwell Time reducer
 */
const inRunSessionCount = buildAsyncStatReducer({
    key: Metrics.INRUN_SESSIONS_COUNT,
    types: {
        request: Types.DASHBOARD_INRUN_SESSIONS_COUNT.request,
        success: Types.DASHBOARD_INRUN_SESSIONS_COUNT.success,
        failure: Types.DASHBOARD_INRUN_SESSIONS_COUNT.failure,
    },
    transform: (state, { payload }) => {
        const { types } = payload
        return { types }
    },
})

/**
 * InRun Dwell Timeline reducer
 */
const inRunDwellTimeline = buildAsyncStatReducer({
    key: Metrics.INRUN_DWELLTIMELINE,
    types: {
        request: Types.DASHBOARD_INRUN_DWELLTIMELINE.request,
        success: Types.DASHBOARD_INRUN_DWELLTIMELINE.success,
        failure: Types.DASHBOARD_INRUN_DWELLTIMELINE.failure,
    },
    transform: (state, { payload }) =>
        Object.keys(payload || {}).reduce((carry, date) => {
            return [
                ...carry,
                {
                    moment: date,
                    time: payload[date],
                },
            ]
        }, []),
})

/**
 * In Run Top Media reducer
 */
const inRunInteractions = buildAsyncStatReducer({
    key: Metrics.INRUN_INTERACTIONS,
    types: {
        request: Types.DASHBOARD_INRUN_INTERACTIONS.request,
        success: Types.DASHBOARD_INRUN_INTERACTIONS.success,
        failure: Types.DASHBOARD_INRUN_INTERACTIONS.failure,
    },
    transform: (state, { payload }) => {
        const { count = 0 } = payload[0] || {}
        return count
    },
})

/**
 * In Run Top Stores reducer
 */
const inRunStoresTopReducer = buildAsyncStatReducer({
    key: Metrics.INRUN_STORES_TOP,
    types: {
        request: Types.DASHBOARD_INRUN_STORES_TOP.request,
        success: Types.DASHBOARD_INRUN_STORES_TOP.success,
        failure: Types.DASHBOARD_INRUN_STORES_TOP.failure,
    },
    transform: (state, { payload }) => {
        return payload.map(({ store_code: storeCode, count }) => ({
            storeCode,
            count,
        }))
    },
})

const inRunReducers = [
    inRunContentReducer,
    inRunContentTopReducer,
    inRunDwellTime,
    inRunDwellTimeline,
    inRunSessionCount,
    inRunInteractions,
    inRunStoresTopReducer,
]

export default inRunReducers
